import { Application, applyTheme, loadTheme } from "@canonical/react-components";
import { SideBar } from "@portal/react-patterns";
import { useLayoutEffect } from "react";
import { navigation } from "./components/navigation/navigation.js";
import { AppRoutes } from "./components/navigation/Routes.js";
import { sendJson } from "./components/utilities/frontEndConfig.js";

export const AppShell = () => {
  useLayoutEffect(() => {
    const theme = loadTheme();
    applyTheme(theme);
  }, []);

  return (
    <Application>
      <SideBar navigation={navigation} sendJson={sendJson} />
      <AppRoutes />
    </Application>
  );
};

export default AppShell;
